import { useState, useEffect, useRef } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';

const MsisdnSearch = ({ onSubmit, loading, disabled, title }) => {
  const [msisdn, setMsisdn] = useState(992);
  const buttonRef = useRef(null);

  const handleInputChange = (e) => {
    if (e.value === null || (e.value.toString().length === 3 && e.value.toString().substr(0, 3) !== '992')) {
      setMsisdn(992);
    } else {
      setMsisdn(e.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(msisdn);
  };

  useEffect(() => {
    buttonRef.current?.focus();
  }, [msisdn]);

  const isValid = msisdn.toString().length === 12;

  return (
    <div className="pt-4 px-3">
      {title && (
        <div className="mb-3">
          {title && <h2 className="text-xl font-bold text-white mt-0 mb-1">{title}</h2>}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="flex flex-column md:flex-row gap-2">
          <div className="w-full md:w-6">
            <InputNumber
              value={msisdn}
              pattern="^[992]{3}[0-9]{9}$"
              onChange={handleInputChange}
              placeholder="992XXXXXXXXX"
              useGrouping={false}
              disabled={loading}
              className="w-full"
              inputClassName="w-full"
            />
          </div>
          <div className="w-full md:w-6">
            <Button
              ref={buttonRef}
              label="Поиск"
              className="p-button-primary w-full"
              disabled={!isValid || loading || disabled}
              raised
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default MsisdnSearch;
